import dayjs from 'dayjs';

export function prepareMinMaxForDates(
  venueStartDate: string,
  venueEndDate: string,
  currentStartDate: string,
) {
  const minStartDate = dayjs(venueStartDate);

  const maxStartDate = dayjs(venueEndDate);

  const minEndDate = dayjs(currentStartDate).isSameOrAfter(
    dayjs(venueStartDate),
  )
    ? dayjs(currentStartDate)
    : dayjs(venueStartDate);

  const maxEndDate = dayjs(venueEndDate);

  return { minStartDate, maxStartDate, minEndDate, maxEndDate };
}
